module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm6"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('span', [_vm._v("For")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', [_vm._v("George C. Wolfe who put it into motion,")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', [_vm._v("André Bishop and Bernard Gersten who made it happen,")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_c('span', [_vm._v("and Adele C-T who gave it the spirit")])])])]), _c('a', {
    attrs: {
      "id": "pagev"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02ff0c80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802195005_dedication.vue
// module id = 78
// module chunks = 0